import { idGenerator } from '@/services'

export interface OtherEquipmentConnectionState {
  requestId: string
}

export const InitialState: OtherEquipmentConnectionState = {
  requestId: idGenerator.getNewWebReference()
}
